import { z } from "zod";
export const loginRequestSchema = z.object({
    username: z.string().min(1).max(64),
    password: z.string().min(1).max(256),
});
export const ROLES = ["team", "admin"];
export const roleSchema = z.enum(ROLES);
/* ------------------------------------------------------------------ */
/* Administracao de contas de admin                                    */
/* ------------------------------------------------------------------ */
const adminUsernameSchema = z
    .string()
    .min(3)
    .max(32)
    .regex(/^[a-z0-9][a-z0-9._-]*$/, "Use minusculas, numeros, ponto, hifen ou sublinhado");
export const createAdminSchema = z.object({
    username: adminUsernameSchema,
    /** Opcional: sem senha, o servidor gera uma e devolve em claro uma vez. */
    password: z.string().min(8).max(128).optional(),
});
export const updateAdminSchema = z
    .object({
    username: adminUsernameSchema.optional(),
    password: z.string().min(8).max(128).optional(),
    /** Gera uma senha aleatoria e devolve em claro. */
    resetPassword: z.boolean().optional(),
})
    .refine((v) => Object.keys(v).length > 0, {
    message: "Informe ao menos um campo para alterar",
});
//# sourceMappingURL=auth.js.map